import { useState, useEffect } from 'react'
import axios from 'axios'
import { Select } from 'antd'

const FilterEnterpriseEntry = ({
    filterValue,
    setFilterValue,
    setCurrentPage
}) => {
    const [tempfilterValue, setTempFilterValue] = useState({})
    const [industryFilter, setIndustryFilter] = useState([])
    const [companyTypeFilter, setCompanyTypeFilter] = useState([])
    const [companySizeFilter, setCompanySizeFilter] = useState([])

    useEffect(() => {
        callFilter()
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    const callFilter = () => {
        axios.post('/admin/enterprise_entry/filter')
            .then(function (response) {
                if (response.errcode === 0) {
                    setIndustryFilter(response.data.industries)
                    setCompanyTypeFilter(response.data.company_types)
                    setCompanySizeFilter(response.data.company_sizes)
                }
            })
            .catch(function (error) {
                console.error('请求失败，错误信息为：', error)
            })
    }

    let industryItems = [
        {
            value: '',
            label: '全部'
        },
        ...industryFilter.map((item) => (
            {
                value: item,
                label: item
            }
        ))
    ]

    let companyTypeItems = [
        {
            value: '',
            label: '全部'
        },
        ...companyTypeFilter.map((item) => (
            {
                value: item,
                label: item
            }
        ))
    ]

    let companySizeItems = [
        {
            value: '',
            label: '全部'
        },
        ...companySizeFilter.map((item) => (
            {
                value: item,
                label: item
            }
        ))
    ]

    let auditStatusItems = [
        {
            value: 0,
            label: '全部'
        },
        {
            value: 1,
            label: '未审核'
        },
        {
            value: 2,
            label: '审核通过'
        },
        {
            value: 3,
            label: '审核未通过'
        }
    ]

    const clickIndustryFilter = (value) => {
        setTempFilterValue({ ...tempfilterValue, industry: value })
    }

    const clickCompanyTypeFilter = (value) => {
        setTempFilterValue({ ...tempfilterValue, company_type: value })
    }

    const clickCompanySizeFilter = (value) => {
        setTempFilterValue({ ...tempfilterValue, company_size: value })
    }

    const clickAuditStatusFilter = (value) => {
        setTempFilterValue({ ...tempfilterValue, audit_status: value })
    }

    const clickSubmitFilter = () => {
        setFilterValue({ ...filterValue, ...tempfilterValue })
        setCurrentPage(1)
    }

    const clickResetFilter = () => {
        setFilterValue({ ...filterValue, industry: '', company_type: '', company_size: '', audit_status: 0 })
        callFilter()
        setTempFilterValue({})
    }

    return (
        <div className='public-conditions'>
            <div className='public-conditions-row'>
                <div className='public-condition'>
                    <div className='public-condition-label'>所属行业：</div>
                    <Select
                        value={tempfilterValue.industry}
                        placeholder="请选择"
                        options={industryItems}
                        style={{ width: '220px' }}
                        onChange={(value) => clickIndustryFilter(value)}
                    />
                </div>

                <div className='public-condition'>
                    <div className='public-condition-label'>公司性质：</div>
                    <Select
                        value={tempfilterValue.company_type}
                        placeholder="请选择"
                        options={companyTypeItems}
                        style={{ width: '220px' }}
                        onChange={(value) => clickCompanyTypeFilter(value)}
                    />
                </div>

                <div className='public-condition'>
                    <div className='public-condition-label'>公司规模：</div>
                    <Select
                        value={tempfilterValue.company_size}
                        placeholder="请选择"
                        options={companySizeItems}
                        style={{ width: '220px' }}
                        onChange={(value) => clickCompanySizeFilter(value)}
                    />
                </div>
            </div>

            <div className='public-conditions-row'>
                <div className='public-condition'>
                    <div className='public-condition-label'>审核状态：</div>
                    <Select
                        value={tempfilterValue.audit_status}
                        placeholder="请选择"
                        options={auditStatusItems}
                        style={{ width: '220px' }}
                        onChange={(value) => clickAuditStatusFilter(value)}
                    />
                </div>
            </div>

            <div className='public-conditions-buttons'>
                <div className='public-conditions-button1' onClick={() => { clickSubmitFilter() }}>筛选</div>
                <div className='public-conditions-button2' onClick={() => { clickResetFilter() }}>重置</div>
            </div>
        </div>
    )
}

export default FilterEnterpriseEntry
